import type { TypedFlight_radar } from "./flight_radar.query";
import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import helpers from "helpers/index";
import { TypedUser } from "interface/user.model";
import queryClient, { IQueryParams } from 'queries';
import { TypedJourney } from "./journey.query";
import { TypedCustomer } from "interface/customer.model";
import { Typed_order_meta, TypedTripManifest } from "./trip_manifest.query";
import { TypedTicket } from "./ticket.query";
import { TypedTransactions } from "./transactions.query";
import { TypedInvoices } from "./invoices.query";



export enum ENUM_ORDER_PAYMENT_STATUS {
    PARTIALLY_PAID = 2,
    PAID = 1,
    UNPAID = 0,
}

export enum ENUM_ORDER_STATUS {
    DRAFT = 0, /** Bản nháp */
    DISPATCHED = 1, /** Đã xếp chuyến */
    IN_TRANSIT = 2, /** Đang di chuyển */
    FINISHED = 3, /** Hoàn thành */
    CANCELLED = 9 /** Hủy */
}


export enum ENUM_ORDER_INVOICE_TYPE {
    PERSONAL = 'PERSONAL',
    COMPANY = 'COMPANY'
}

export interface Typedorder_invoice_info {
    id?: string;
    order_id?: string;
    tax_type?: string; /**  enum('PERSONAL', 'COMPANY')  */
    name?: string;
    buyer_name?: string;
    tax_code?: string;
    tax_cccd?: string;
    tax_mamoiquanhengansach?: string;
    invoice_email?: string;
    invoice_phone?: string;
    invoice_address?: string;
    payment_method?: string; /**  enum('CASH', 'TRANSFER')  */
    is_customer_required?: number; /** Người dùng yêu cầu à? */
    createdAt?: string;


    invoice_save_to_invoice_list?: number; /** Tùy chọn lưu lại xuất cho lần sau ... */
}

export enum ENUM_ORDER_FEE {
    PICKUP_FEE = 'PICKUP_FEE',
    DROPOFF_FEE = 'DROPOFF_FEE',
    PARKING_FEE = 'PARKING_FEE',
    LUGGAGE_FEE = 'LUGGAGE_FEE',
    TOLL_FEE = 'TOLL_FEE',
    OTHER_FEE = 'OTHER_FEE',
}


// Map enum -> label (tên hiển thị)
export const ORDER_FEE_LABEL: Record<ENUM_ORDER_FEE, string> = {
    [ENUM_ORDER_FEE.PICKUP_FEE]: 'Phí đón',
    [ENUM_ORDER_FEE.DROPOFF_FEE]: 'Phí trả',
    [ENUM_ORDER_FEE.PARKING_FEE]: 'Phí chờ',
    [ENUM_ORDER_FEE.TOLL_FEE]: 'Phí cao tốc',
    [ENUM_ORDER_FEE.LUGGAGE_FEE]: 'Phí hành lý',
    [ENUM_ORDER_FEE.OTHER_FEE]: 'Phí khác',
};



export enum ENUM_TRIP_FEE {
    FUEL_FEE = 'FUEL_FEE',
    PARKING_FEE = 'PARKING_FEE',
    REPAIR_MAINTENANCE_FEE = 'REPAIR_MAINTENANCE_FEE',
    TOLL_FEE = 'TOLL_FEE',
    RELAY_TRANSFER_FEE = 'RELAY_TRANSFER_FEE',      // thuê Grab/xe ôm giao – nhận hộ
    OTHER_FEE = 'OTHER_FEE',
}


export const TRIP_FEE_LABELS: Record<ENUM_TRIP_FEE, string> = {
    [ENUM_TRIP_FEE.FUEL_FEE]: 'Đổ nhiên liệu',
    [ENUM_TRIP_FEE.PARKING_FEE]: 'Vé gửi xe',
    [ENUM_TRIP_FEE.REPAIR_MAINTENANCE_FEE]: 'Sửa xe/Bảo dưỡng',
    [ENUM_TRIP_FEE.TOLL_FEE]: 'Phí cao tốc/Trạm thu phí',
    [ENUM_TRIP_FEE.RELAY_TRANSFER_FEE]: 'Trung chuyển/Thuê ngoài (Grab/xe ôm)',
    [ENUM_TRIP_FEE.OTHER_FEE]: 'Phí khác',
};

export interface TypedOrderCallLog {
    id?: bigint;
    order_id?: bigint;
    call_status?: string;
    caller?: bigint;
    createdAt?: bigint;
    caller_data?: TypedUser;
    order_data?: TypedOrders;
}


export interface TypedOrders {


    id?: string;
    order_code?: string;
    departure_date?: number | string;
    pickup_time?: string;
    pickup_address?: string;
    pickup_place_id?: string;


    pickup_province?: string,
    pickup_district?: string,
    pickup_ward?: string,
    pickup_note?: string,

    pickup_contact_name?: string;
    pickup_contact_phonenumber?: string;


    dropoff_address?: string,
    dropoff_contact_name?: string,
    dropoff_contact_phonenumber?: string,

    dropoff_province?: string,
    dropoff_district?: string,
    dropoff_ward?: string,
    dropoff_note?: string,


    dropoff_place_id?: string;

    customer_id?: string;
    customer_name?: string;
    customer_phone?: string;

    journey_id?: string;
    trip_manifest_id?: string;
    trip_id?: string;
    total_fee?: number;
    total_must_pay?: number;
    total_paid?: number;
    total_seat?: number;
    payment_status?: ENUM_ORDER_PAYMENT_STATUS;
    note?: string;
    order_status?: ENUM_ORDER_STATUS; // ENUM_ORDER_STATUS
    order_tag_color?: string; /** đánh màu hệ hexa cho đơn hàng để tài xế nhìn tag màu, ví dụ đỏ #ff0000 */
    is_locked?: number; // 1 là khóa tịt, 0 là cho phép điều chỉnh .... 
    createdBy?: string;
    createdAt?: string;


    author_data?: TypedUser;
    customer_data?: TypedCustomer;
    journey?: TypedJourney
    ticket?: TypedTicket[];
    order_meta?: Typed_order_meta;

    /** Để đặt vé */
    price_table?: {
        price?: number,
        discount?: number,
        ticket_type?: string,
        seat_position?: string,
        /** dành cho update */
        ticket_id?: bigint,
    }[]

    /** Để đặt vé */
    order_fee?:
    {
        fee_description: string,
        fee_value: number,
    }[],
    order_invoice_info?: Typedorder_invoice_info,
    transactions?: TypedTransactions[],

    trip_manifest?: TypedTripManifest;
    invoices?: TypedInvoices

    flight_radar_to_order?: {
        flight_radar?: TypedFlight_radar | null;
    } | null;

    order_call_log?: TypedOrderCallLog[]

}


type IQuery = TypedOrders & IQueryParams;



interface TypedOrder_log {
    id?: string;
    order_id?: string;
    action?: string;
    payload?: JSON;
    createdAt?: string;

    orders?: {
        order_code: string,
        id: string
    },
    author_data?: {
        user_id?: true,
        display_name?: true,
        user_phonenumber?: true,
    }
}


/*
* List of all Orders
*/
export function useGetOrders(object: IQuery, enabled = true) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["orders/fetch_entity_list", object],
        queryFn: () => axios.get<TypedOrders[]>(`/orders/${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                entities: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        enabled: enabled && !!object
    });
}

/** Widget tại trang chủ êi nhaaaa */
export function useGetOrdersUnExportInvoiceToday() {
    return useQuery({
        queryKey: ["orders/unexport_invoice_today"],
        queryFn: () => axios.get<TypedOrders[]>(`/orders/unexport_invoice_today/`).then(response => response.data),
        refetchOnReconnect: true,
        refetchInterval: 15000
    });
}

export function useGetOrdersTransactions() {
    return useMutation({
        mutationKey: ["orders/fetch_list_transactions_in_manifest"],
        mutationFn: (manifest_id: string | bigint) => axios.get<TypedTransactions[]>(`/orders/transaction_list/${manifest_id}`).then(response => response.data),
        retry: 1,
    });
}


export function useOrderClearTransaction() {
    return useMutation({
        mutationKey: ["orders/clear_order_transaction"],
        mutationFn: (order_id: string | bigint) => axios.delete<any>(`/orders/clear_transaction/${order_id}`).then(response => response.data),
        retry: 1,
    });
}


/** Order log */
export function useGetOrderLogInManifest() {
    return useMutation({
        mutationKey: ["orders/fetch_list_order_log_in_manifest"],
        mutationFn: (manifest_id: string | bigint) => axios.get<TypedOrder_log[]>(`/order_log/${manifest_id}`).then(response => response.data),
        retry: 1,
    });
}

/** Lấy ra danh sách order log */
export function useGetOrderLog(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["order_log/fetch_entity_list", object],
        queryFn: () => axios.get<TypedOrder_log[]>(`/order_log/${EndURL}`).then(response => response.data),
        retry: 1,
        enabled: !!object
    });
}


export function useGetOrder(id: string) {
    return useQuery({
        queryKey: ["orders/fetch_entity", id],
        queryFn: () => axios.get<TypedOrders>(`/orders/${id}`).then(response => response.data),
        retry: 1,
        refetchOnMount: true,
        enabled: !!id
    });
}


export function useMutateGetOrderViaCode() {
    return useMutation({
        mutationKey: ["orders/fetch_entity"],
        mutationFn: (order_code: string) => axios.get<TypedOrders>(`/orders/get_via_code/${order_code}`).then(response => response.data),
        retry: 1,
    });
}


export function useMutateGetOrders() {
    return useMutation({
        mutationKey: ["orders/fetch_list_order"],
        mutationFn: (object: IQuery) => axios.get<TypedOrders[]>(`/orders/${helpers.buildEndUrl(object)}`).then(response => response.data),
        retry: 1,
    });
}
export function useMutateSearchOrders() {
    return useMutation({
        mutationKey: ["orders/quick_search"],
        mutationFn: (object: IQuery) => axios.get<TypedOrders[]>(`/orders/quicksearch/${helpers.buildEndUrl(object)}`).then(response => response.data),
        retry: 1,
    });
}

export function useMutateUpdateOrder() {
    return useMutation({
        mutationKey: ["orders/fetch_list_order"],
        mutationFn: ({ id, ...rest }: TypedOrders) => axios.patch<TypedOrders>(`/orders/${id}`, rest).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị

        },
        retry: 1,
    });
}



/** Admin thanh toán cho vé ... */
export function useMutateOrderPaid() {
    return useMutation({
        mutationKey: ['orders/admin_paid'],
        mutationFn: (payload: {
            casher?: bigint,
            payment_method: string,
            description: string,
            order_id: bigint,
            amount: number,
        }) => axios.post(`/orders/paid`, payload).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
        }
    });
}



/** Admin book vé ... */
export function useMutateOrderBooking() {
    return useMutation({
        mutationKey: ['orders/admin_booking'],
        mutationFn: (body: TypedOrders & { user_tax_information_id?: any }) => axios.post<TypedOrders[]>(`/orders`, body).then((response) => response.data),
        onSuccess: () => {
            /** Load lại trip */
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            // queryClient.invalidateQueries({ queryKey: ['orders/fetch_list_order'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            // queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị
        }
    });
}

/** Admin hủy vé ... */
export function useMutateOrderCancel() {
    return useMutation({
        mutationKey: ['orders/admin_cancel'],
        mutationFn: (order_id: number | string) => axios.delete(`/orders/cancel/${order_id}`).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            // queryClient.invalidateQueries({ queryKey: ['orders/fetch_list_order'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            // queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị

        }
    });
}

/** 
 * Admin xóa vé 
 * Xóa vé là xóa luôn cả thanh toán và thông tin thuế, vé sẽ không còn tồn tại nữa
*/
export function useMutateOrderRemove() {
    return useMutation({
        mutationKey: ['orders/admin_remove'],
        mutationFn: (order_id: number | string) => axios.delete(`/orders/remove/${order_id}`).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip/fetch_entity_list'] });
            // queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity_list'] });
            // queryClient.invalidateQueries({ queryKey: ['orders/fetch_list_order'] });
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });
            // queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị
        }
    });
}



/** Cập nhật thông tin thuế của đơn hàng, trả về 201 updated ... */
export function useMutateOrderTaxInformation() {
    return useMutation({
        mutationKey: ['orders/order_invoice_info_update'],
        mutationFn: (data: Typedorder_invoice_info) => axios.patch<void>(`/order_invoice_info/${data.order_id}`, data).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });

            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị

        }
    });
}


/** Xóa bỏ thông tin thuế */
export function useMutateDeleteOrderTaxInformation() {
    return useMutation({
        mutationKey: ['orders/delete_order_invoice_info'],
        mutationFn: (order_id: any) => axios.delete<void>(`/order_invoice_info/${order_id}`).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['trip_manifest/fetch_entity'] });

            queryClient.invalidateQueries({ queryKey: ['orders/fetch_entity'] });
            queryClient.invalidateQueries({ queryKey: ['ticket/fetch_entity_list'] }); // reset lại cái danh sách vé để hiển thị

        }
    });
}


/** Người dùng yêu cầu xuất hóa đơn ... màn hình ngoài */
export function useGetTaxFillOrder(order_code: string) {
    return useQuery({
        queryKey: ["taxfill/fetch_order", order_code],
        queryFn: () => axios.get<{ valid: boolean, order_data: TypedOrders, note: string }>(`/taxfill/order/${order_code}`).then(response => response.data),
        retry: 1,
        refetchOnMount: true,
        enabled: !!order_code
    });
}


/** Cập nhật thông tin thuế cho màn tax-fill public */
export function useMutateTaxFillOrderTaxInformation() {
    return useMutation({
        mutationKey: ['taxfill/order_invoice_info_update'],
        mutationFn: (data: Typedorder_invoice_info) => axios.put<void>(`/taxfill/order_invoice_info/${data.order_id}`, data).then((response) => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['taxfill/fetch_order'] });
        }
    });
}
